var _effectorFileName = "/src/page-content/home/ui.tsx";
import { useRouter } from 'next/router';
import { WebPageJsonLd } from 'next-seo';
import { MainLayout } from '@/widgets/layouts/main';
import { CallToAction } from '@/widgets/layouts/main/call-to-action';
import { SERVICES_LIST } from '@/widgets/layouts/main/constants/services-list';
import { ForWhomOurLessons } from '@/widgets/layouts/main/for-whom-our-lessons';
import { Partners } from '@/widgets/layouts/main/partners';
import { Pricing } from '@/widgets/layouts/main/pricing/pricing';
import { Reviews } from '@/widgets/layouts/main/reviews';
import { StudentsCases } from '@/widgets/layouts/main/students-cases';
import { PageSeo } from '@/shared/lib/seo';
import { APP_TITLE } from '@/shared/lib/seo/meta';
import { LessonsExamples } from '../for-companies/components/lessons-examples';
import { CARDS } from '../group-lessons/constants/cards';
import { Main } from './components/main';
import { WhyWorkWithUs } from './components/why-work-with-us/why-work-with-us';
export const HomePage = () => {
  const router = useRouter();
  return <>
      <PageSeo title="Английский для работы, экзаменов, собеседований и путешествий" description="Прокачаем ваш английский и поможем открыть новые возможности" />

      <WebPageJsonLd id={router.asPath} url={`${process.env.NEXT_PUBLIC_APP_URL}`} name={`${APP_TITLE} - Английский для работы, экзаменов, собеседований и путешествий`} isPartOf={`${process.env.NEXT_PUBLIC_APP_URL}`} description="Прокачаем ваш английский и поможем открыть новые возможности" about={['английский язык', 'онлайн', 'консультации', 'английский язык для работы', 'английский язык для путешествий', 'английский язык для экзаменов', 'английский язык для собеседований']} />

      <Main />

      <ForWhomOurLessons />

      <WhyWorkWithUs />

      <Partners />

      {/* <SliderCards cards={CARDS} /> */}

      <LessonsExamples />

      <Pricing servicesList={SERVICES_LIST} />

      <StudentsCases />

      <Reviews />

      <CallToAction withForm header="Записывайтесь на бесплатное занятие" description="Мы свяжемся с вами и подберем удобное время" />
    </>;
};
HomePage.Layout = MainLayout;